import { useState, useEffect } from 'react';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      const width = window.visualViewport
        ? window.visualViewport.width
        : window.innerWidth;
      const isIPad =
        /iPad/.test(navigator.userAgent) ||
        (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document);
      setIsMobile(width < 1024 || isIPad);
    };

    checkIsMobile();

    const resizeListener = () => {
      checkIsMobile();
    };

    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
